import { render, staticRenderFns } from "./WeeklyOrderPage.vue?vue&type=template&id=f62ff59c"
import script from "./WeeklyOrderPage.vue?vue&type=script&lang=js"
export * from "./WeeklyOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports